import { create } from 'zustand'
import type { LiveAnalyticsSnapshot } from '../types'

interface AnalyticsState {
  snapshot: LiveAnalyticsSnapshot | null
  setSnapshot: (snapshot: LiveAnalyticsSnapshot) => void
  clearSnapshot: () => void
}

export const useAnalyticsStore = create<AnalyticsState>()((set) => ({
  snapshot: null,
  setSnapshot: (snapshot) => set({ snapshot }),
  clearSnapshot: () => set({ snapshot: null }),
}))
